module.exports = __webpack_public_path__ + "static/media/shipping-confirm.1ea5b248.jpg";